module.exports = __webpack_public_path__ + "static/media/slick.f97e3bbf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.svg
// module id = 2930
// module chunks = 0